import { useContext } from 'react'
import CustomDatePicker from '../../components/DatePicker'
import { StatisticsContext } from '../../context/StatisticsContext'
import dayjs from 'dayjs'
import CustomDropdown from '../../components/Dropdown'
import { formatDateStringToLocalDate } from '../../helpers/utils'
import GoBackButton from '../../components/GoBackButton'
import { useNavigate } from 'react-router-dom'
import { AppRoutes } from '../../helpers/routes'

const StatisticsHeader = ({ category }: { category?: string }) => {
    const navigate = useNavigate()
    const { startDate, setStartDate, endDate, setEndDate, carreer, setCarreer, allCarreers } =
        useContext(StatisticsContext)

    return (
        <div className="flex flex-col gap-2">
            <div className="flex gap-4 items-center">
                {!!category && (
                    <GoBackButton navigate={() => navigate(AppRoutes.statistics.main)} />
                )}
                <div className="flex gap-2 items-end flex-nowrap">
                    <span className="text-xl md:text-3xl font-semibold text-primary">
                        Estadísticas
                    </span>
                    <span className="text-base md:text-2xl font-semibold text-primary whitespace-nowrap">
                        {category ? '/ ' + category : ''}
                    </span>
                </div>
            </div>
            <div className="flex flex-col md:flex-row gap-2 md:gap-5 items-start md:items-center">
                <div className="min-w-full md:min-w-[400px] flex flex-col mt-1">
                    <CustomDropdown
                        label="Carrera"
                        name="carrer"
                        value={carreer ?? ''}
                        onChange={(e) =>
                            setCarreer(
                                e.target.value === 'Limpiar' ? '' : (e.target.value as string),
                            )
                        }
                        data={['Limpiar', ...allCarreers]}
                    />
                </div>
                <div className="w-[220px] flex flex-col">
                    <CustomDatePicker
                        name="startDate"
                        label="Año límite inferior"
                        value={startDate}
                        onChange={(_, value) => setStartDate(value)}
                        onlyYear
                        minValue={dayjs('1980-06-06')}
                        maxValue={endDate ? dayjs(formatDateStringToLocalDate(endDate)) : dayjs()}
                        clearable
                    />
                </div>
                <div className="w-[220px] flex flex-col">
                    <CustomDatePicker
                        name="endDate"
                        label="Año límite superior"
                        value={endDate}
                        onChange={(_, value) => setEndDate(value)}
                        onlyYear
                        minValue={
                            startDate ? dayjs(formatDateStringToLocalDate(startDate)) : undefined
                        }
                        maxValue={dayjs()}
                        clearable
                    />
                </div>
            </div>
        </div>
    )
}

export default StatisticsHeader
